<script setup lang="ts">
import type { DropdownItem } from '#ui/types'

const props = defineProps<{
  row: Partial<Note> & Pick<Note, 'tableName' | 'recordId' | 'userId'>
  dropdownItems?: DropdownItem[][]
}>()

const { moduleId } = useModules()
</script>

<template>
  <!-- IMPORTANT: must use CSS variables and not e.g. `border-[toHexColor(row.userId)]`
  directly since TailwindCSS will not pick-up dynamic CSS colors outside of the SSR (on client) -->
  <div
    :id="`note-${row.id}`"
    class="w-full h-min p-2 rounded-md bg-gray-100 dark:bg-gray-800"
    :style="{ '--dynamic-color': toHexColor(row.userId) }"
  >
    <header class="flex items-center justify-between text-xs py-1">
      <div class="flex items-center gap-2">
        <UAvatar
          :title="row.user?.name"
          :src="row.user?.image"
          :alt="row.user?.name"
          size="xs"
          class="border border-[var(--dynamic-color)]"
          :style="{ '--dynamic-color': toHexColor(row.userId) }"
        />
        <span
          :title="row.user?.email"
          class="text-[var(--dynamic-color)] font-medium text-xs"
          :style="{ '--dynamic-color': toHexColor(row.userId) }"
        >
          {{ row.user?.name?.toUpperCase() ?? row.user?.email }}
        </span>
      </div>
      <div class="ml-auto flex items-center gap-2">
        <ViewRendererDatetime
          :datetime="row.createdAt"
          exact
          display-hours
        />
        <Can
          v-if="dropdownItems?.length"
          :ability="update"
          :args="[moduleId]"
        >
          <UDropdown
            :items="dropdownItems"
            :popper="{ placement: 'auto-start' }"
            :ui="{ width: 'min-w-max' }"
          >
            <UButton
              icon="i-mdi-dots-horizontal"
              variant="ghost"
              size="2xs"
              square
            />
          </UDropdown>
        </Can>
      </div>
    </header>

    <!-- NOTE: could add e.g. `class="max-h-[500px] overflow-y-auto"` to limit card height -->
    <MarkdownRenderer :value="row.text" />
  </div>
</template>
